export default "__VITE_ASSET__C2wL3imn__"